import React, { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { Button } from './Button';
import { Modal } from './Modal';
import useTheme from '../hooks/useTheme';

export const Header: React.FC = () => {
    const { theme } = useTheme();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const location = useLocation();

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/partners', label: 'Partners' },
        { path: '/events', label: 'Events' },
        { path: '/news', label: 'News' },
        { path: '/membership', label: 'Membership' },
        { path: '/contact', label: 'Contact' },
    ];

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <>
            <header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                    backgroundColor: theme.background.panel,
                    borderBottom: `1px solid ${theme.colors.line}`,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                }}
            >
                <div
                    style={{
                        background: `linear-gradient(90deg, ${theme.colors.accent.korea} 0%, ${theme.colors.accent.egypt} 100%)`,
                        height: '2px',
                        width: '100%',
                    }}
                />
                <div
                    style={{
                        maxWidth: '1120px',
                        margin: '0 auto',
                        padding: '16px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '24px',
                    }}
                >
                    <Link
                        to="/"
                        style={{
                            textDecoration: 'none',
                            color: theme.text.primary,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <div style={{ fontSize: '24px', fontWeight: 700, letterSpacing: '-0.5px' }}>
                            BCBH
                        </div>
                        <div style={{ fontSize: '11px', color: theme.text.muted, letterSpacing: '0.5px' }}>
                            BUSAN–CAIRO BUSINESS HUB
                        </div>
                    </Link>

                    <nav
                        className="headerNav"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '32px',
                            flex: 1,
                            justifyContent: 'center',
                        }}
                    >
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={isActive(link.path) ? 'navLinkActive' : 'navLink'}
                                style={{
                                    textDecoration: 'none',
                                    color: isActive(link.path) ? theme.colors.green.g1 : theme.text.muted,
                                    fontSize: '15px',
                                    fontWeight: isActive(link.path) ? 500 : 400,
                                    transition: 'color 0.2s ease',
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                        className="headerActions"
                    >
                        <Button
                            variant="secondary"
                            onClick={() => setIsOpportunityModalOpen(true)}
                            style={{ fontSize: '14px', padding: '10px 18px' }}
                        >
                            Submit Opportunity
                        </Button>
                        <Link to="/membership" style={{ textDecoration: 'none' }}>
                            <Button variant="primary" style={{ fontSize: '14px', padding: '10px 18px' }}>
                                Join Waitlist
                            </Button>
                        </Link>
                    </div>

                    <button
                        className="hamburgerBtn"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        style={{
                            display: 'none',
                            background: 'transparent',
                            border: 'none',
                            color: theme.text.primary,
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '8px',
                        }}
                        aria-label="Toggle menu"
                    >
                        ☰
                    </button>
                </div>

                {isMenuOpen && (
                    <div
                        className="mobileMenu"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '20px',
                            gap: '16px',
                            borderTop: `1px solid ${theme.colors.line}`,
                        }}
                    >
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                onClick={() => setIsMenuOpen(false)}
                                style={{
                                    textDecoration: 'none',
                                    color: isActive(link.path) ? theme.colors.green.g1 : theme.text.muted,
                                    fontSize: '16px',
                                    padding: '8px 0',
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setIsOpportunityModalOpen(true);
                                    setIsMenuOpen(false);
                                }}
                            >
                                Submit Opportunity
                            </Button>
                            <Link to="/membership" style={{ textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>
                                <Button variant="primary">Join Waitlist</Button>
                            </Link>
                        </div>
                    </div>
                )}
            </header>

            <Modal
                isOpen={isOpportunityModalOpen}
                onClose={() => setIsOpportunityModalOpen(false)}
                title="Business Opportunities Exchange"
            >
                <p style={{ color: theme.text.muted, lineHeight: 1.6, marginBottom: '16px' }}>
                    The Business Opportunities Exchange is coming soon in Phase 2 of the BCBH portal.
                </p>
                <p style={{ color: theme.text.muted, lineHeight: 1.6 }}>
                    This feature will allow members to submit business opportunities, search for partners,
                    and connect Korean and Egyptian companies for collaboration.
                </p>
                <div style={{ marginTop: '24px' }}>
                    <Button variant="primary" onClick={() => setIsOpportunityModalOpen(false)}>
                        Got it
                    </Button>
                </div>
            </Modal>
        </>
    );
};

